import "./src/css/main.css"
/*
export const onInitialClientRender = () => {
    $(document).ready(function () {
        $("img").parents('p').css("text-align", "center");
    });
  }
  */

const $ = require("jquery")

export const onInitialClientRender = () => {

 

  $( document ).on( 'ready', function (e) {
    $("img").parents('p').css("text-align", "center");
   })


}